module.exports = __webpack_public_path__ + "static/ELBA_Areal_Protokoll_Bewertungsgremium-bffc9f143eb392ed0ec23d4c5078f209.pdf";